import { AuthLayout } from "./AuthLayout";
import Layout from "./Layout";

export const Layouts = {
  Main: Layout,
  Auth: AuthLayout
};
export type LayoutKeys = keyof typeof Layouts;
